import { CSSProperties } from "react";

export const styles: Record<string, CSSProperties> = {
  text: {
    textAlign: "center",
  },
  checkMark: {
    display: "block",
    marginLeft: "auto",
    marginRight: "auto",
  },
};
